import { useEffect } from "react";
import { MERCHANT_PORTAL_BASE, DEFAULT_OG_IMAGE, TWITTER_HANDLE } from "../constants/seo";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  if (!data) return;
  const script = document.createElement("script");
  script.id = id;
  script.type = "application/ld+json";
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

/**
 * Lightweight per-route SEO (title, meta, OG, canonical, optional JSON-LD).
 */
export default function SeoHead({
  title,
  description,
  pathname,
  image = DEFAULT_OG_IMAGE,
  robots = "index, follow, max-image-preview:large",
  jsonLd,
  jsonLdId = "qt-page-jsonld",
}) {
  const canonical =
    pathname && pathname.startsWith("http")
      ? pathname
      : `${MERCHANT_PORTAL_BASE}${pathname || "/"}`;

  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots);
    upsertLink("canonical", canonical);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "QikTruck Business");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:site", `@${TWITTER_HANDLE}`);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    upsertJsonLd(jsonLdId, jsonLd);
  }, [title, description, canonical, image, robots, jsonLd, jsonLdId]);

  return null;
}
